import { useCallback, useEffect, useState } from "react";
import MultiItemSelectDropdown from "../inputs/MultiItemSelectDropdown";
import AppContext from "../context/AppContext";
import SelectDropdown from "../inputs/SelectDropdown";
import { getSupplierLocationsUrl, getTravellers } from "../utils";
import FromToDateField from "../inputs/FromToDateField";

export default function EasyOTAFormTransfer({ onSubmit, supplierId, supplierLoc, supplierSettings }) {
   const [locations, setLocations] = useState([]);
   const [destinations, setDestinations] = useState([]);
   const [submitData, setSubmitData] = useState({
      rooms: 1,
      nights: 1,
   });
   const [popupsListeners, setPopupsLisners] = useState([]);
   const [travellers, setTravellers] = useState({});
   const travellersItems = getTravellers(supplierSettings);
   const popupCloseEvent = () => {
      popupsListeners.forEach((handler) => {
         handler();
      });
   };

   const registerPops = useCallback((handler) => {
      setPopupsLisners((prev) => {
         return [...prev, handler];
      });
   }, []);

   const handleOnChange = useCallback(
      ({ name, value }) => {
         if (name === "location") {
            let pickupLoc = value;
            console.log("Location select: ", { pickupLoc, supplierLoc });
            let pickupIsSupplier = !pickupLoc ? false : pickupLoc.location.id === supplierLoc.location.id;
            let fixedDropoffLoc = pickupLoc && !pickupIsSupplier ? supplierLoc : null;
            // fixedDropoffLoc = null; //Disable locking
            let newDests = fixedDropoffLoc ? [fixedDropoffLoc] : [...locations];
            setDestinations(newDests);
         }
         setSubmitData((prev) => {
            return {
               ...prev,
               [name]: value,
            };
         });
      },
      [locations, supplierLoc]
   );

   const handleSubmit = (ev) => {
      ev.preventDefault();
      onSubmit && onSubmit({ ...submitData, travellers });
   };
   const handleOnChangeMult = (params) => {
      setSubmitData((prev) => {
         return {
            ...prev,
            ...params,
         };
      });
   };

   useEffect(() => {
      if (supplierId) {
         let isOrigin = false;
         fetch(getSupplierLocationsUrl(supplierId, isOrigin))
            .then((res) => res.json())
            .then((json) => {
               setLocations(json);
            });
      }
   }, [supplierId]);
   return (
      <AppContext.Provider value={{ registerPopupListener: registerPops, popupCloseEvent }}>
         <div className='form'>
            <form action='#' method='post' id='search-form' onSubmit={handleSubmit} autoComplete='off'>
               <div className='fields'>
                  <SelectDropdown
                     field='location'
                     label='Pickup From'
                     hint='Country, city or airport'
                     options={locations}
                     onChange={handleOnChange}
                     defaultOption={supplierSettings.defaultPickupLocation}
                  />
                  <SelectDropdown
                     field='dropoff'
                     label='Drop Off To'
                     hint='Country, city or airport'
                     options={destinations}
                     onChange={handleOnChange}
                  />
                  <FromToDateField
                     params={{
                        from: {
                           field: "departure_date",
                           label: "From",
                           withTime: {
                              field: "departure_time",
                              label: "Pickup Time",
                           },
                        },
                        to: {
                           field: "return_date",
                           label: "To",
                           withTime: {
                              field: "return_time",
                              label: "Pickup Time",
                              anyTime: true,
                           },
                        },
                     }}
                     minDate={new Date()}
                     required
                     onChange={handleOnChangeMult}
                  />
                  <MultiItemSelectDropdown
                     field='travellers'
                     label='Travellers'
                     items={travellersItems}
                     data={travellers}
                     settings={supplierSettings}
                     onChange={(selected) => {
                        setTravellers((prev) => {
                           return {
                              ...prev,
                              ...selected,
                           };
                        });
                     }}
                     required
                     validity='You must select atleast 1 adult'
                  />
               </div>
               <button className='btn'>Search</button>
            </form>
         </div>
      </AppContext.Provider>
   );
}
